import {combineReducers} from "redux";
import resultReducer from "./result";


const rootReducer = combineReducers({
    result: resultReducer
});

export default rootReducer;
